import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './shell/Layout';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import { SigningIn } from './pages/SigningIn';
import { SignedOut } from './pages/SignedOut';
import { Login } from './pages/Login';
import { ComingSoon } from './components/ComingSoon';
import { Settings } from './pages/Settings';
import { Changelog } from './pages/Changelog';
import { InventoryCount } from './pages/InventoryCount';
import { CountSession } from './pages/CountSession';
import { InventoryVariance } from './pages/InventoryVariance';
import { Today } from './pages/Today';
import { MyStore } from './pages/MyStore';
import { Comms } from './pages/Comms';
import { Performance } from './pages/Performance';
import { Promotions } from './pages/Promotions';
import { Recognition } from './pages/Recognition';
import { Paperwork } from './pages/Paperwork';
import { Pulse } from './pages/Pulse';
import { Loyalty } from './pages/Loyalty';
import { Sampling } from './pages/Sampling';
import { Resources } from './pages/Resources';
import { Directory } from './pages/Directory';
import { KioskEnrollment } from './pages/KioskEnrollment';
import { TabletEnrollment } from './pages/TabletEnrollment';
import { HqStoreProvider } from './lib/HqStoreProvider';

export default function App() {
  return (
    <HqStoreProvider>
    <Routes>
      {/*
        /auth/callback is a public safety-net route. The API's auth-callback
        handler normally 302-redirects before the SPA loads. If the browser
        arrives here without a redirect, show a "Signing you in..." placeholder.
      */}
      <Route path="/auth/callback" element={<SigningIn />} />
      {/*
        /signin is the email-first sign-in page. Public, OUTSIDE the Layout so
        AuthGate does not gate it. The user types their work email and the page
        routes by domain: @ampersandbrands.com -> Microsoft Entra,
        @lolliandpops.com -> Google. AuthGate sends unauthenticated users here.
      */}
      <Route path="/signin" element={<Login />} />
      {/*
        /signed-out is the landing page after a local logout. It sits OUTSIDE
        the Layout so it isn't gated by AuthGate (which would silent-SSO the
        user right back in and make sign-out feel broken).
      */}
      <Route path="/signed-out" element={<SignedOut />} />
      {/* Public browser-to-app handoff for one-time native kiosk enrollment. */}
      <Route path="/kiosk-enroll" element={<KioskEnrollment />} />
      <Route path="/tablet-enroll" element={<TabletEnrollment />} />

      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />

        {/* Tool tiles. Every one is a shared ComingSoon placeholder until the
            real page is built; swapping the element is the only change each
            tool build needs to make here. */}
        <Route path="/today" element={<Today />} />
        <Route path="/inventory" element={<InventoryCount />} />
        <Route path="/inventory/variance" element={<InventoryVariance />} />
        <Route path="/inventory/:id" element={<CountSession />} />
        {/* Questions folded into chat (the floating bubble). Old links redirect. */}
        <Route path="/questions" element={<Navigate to="/" replace />} />
        <Route path="/my-store" element={<MyStore />} />
        <Route path="/paperwork" element={<Paperwork />} />
        <Route path="/comms" element={<Comms />} />
        <Route path="/schedule" element={<ComingSoon title="Schedule" />} />
        <Route path="/resources" element={<Resources />} />
        {/* Training was renamed to Resources. Keep the old path working so
            bookmarks, tablet home screens and anything already linked still
            land somewhere. */}
        <Route path="/training" element={<Navigate to="/resources" replace />} />
        <Route path="/performance" element={<Performance />} />
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/recognition" element={<Recognition />} />
        <Route path="/pulse" element={<Pulse />} />
        <Route path="/loyalty" element={<Loyalty />} />
        <Route path="/sampling" element={<Sampling />} />
        <Route path="/directory" element={<Directory />} />
        {/* Chat is the floating bubble on every page now; old /chat links redirect. */}
        <Route path="/chat" element={<Navigate to="/" replace />} />
        <Route path="/settings" element={<Settings />} />
        {/* What's new. Reached from the avatar menu, not the bottom nav, so it
            gets no navDefs entry (that would put it in the bar picker). */}
        <Route path="/changelog" element={<Changelog />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </HqStoreProvider>
  );
}
